export const SKILLSETS_ACCESSOR = 'skillsets';
export const SKILLSET_IDS_ACCESSOR = 'skillsetIds';
export const SKILLSETS_EDITORDEF = {
  loadDefinition: 'default'
};